import {
    EMAIL_EXISTED,
    EMAIL_INVALID,
    EMAIL_NOT_EXISTED,
    NEED_BE_ACTIVATED,
    USERNAME_INVALID,
    WRONG_PASSWORD
} from './error-codes';

const ERROR_CLASS = 'has-error';

const ERROR_STATUS_VALIDATION_FORM = 417;

export const renderErrorByResponse = (response, parent) => {
    if (response.status !== undefined && response.status === ERROR_STATUS_VALIDATION_FORM) {
        for (const field in JSON.parse(response.data.message)) {
            parent.find(`input[name="${field}"]`).parents('.form-input').addClass(ERROR_CLASS);
        }
    }

    parent.find('input[name="name"]').parents('.form-group').removeClass(ERROR_CLASS);
    parent.find('input[name="password"]').parents('.form-group').removeClass(ERROR_CLASS);
    parent.find('input[name="email"]').parents('.form-group').removeClass(ERROR_CLASS);
    parent.find('input[name="confirm_password"]').parents('.form-group').removeClass(ERROR_CLASS);

    switch (response.data.code) {
        case USERNAME_INVALID:
            parent.find('input[name="name"]').parents('.form-group').addClass(ERROR_CLASS);
            break;

        case EMAIL_INVALID:
        case EMAIL_EXISTED:
        case EMAIL_NOT_EXISTED:
            parent.find('input[name="email"]').parents('.form-group').addClass(ERROR_CLASS);
            break;

        case NEED_BE_ACTIVATED:
            window.location.href = response.data.redirect;

            break;

        case WRONG_PASSWORD:
            parent.find('input[name="password"]').parents('.form-group').addClass(ERROR_CLASS);
            parent.find('input[name="confirm_password"]').parents('.form-group').addClass(ERROR_CLASS);
            parent.find('input[name="password"]').parents('.form-group').find('.error-label').text(response.data.message);
            parent.find('input[name="confirm_password"]').parents('.form-group').find('.error-label').text(response.data.message);
            break;
    }
};
